import { render, staticRenderFns } from "./SyncAdvertisementButton.vue?vue&type=template&id=38edaad4&"
import script from "./SyncAdvertisementButton.vue?vue&type=script&lang=ts&"
export * from "./SyncAdvertisementButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports